import { render, staticRenderFns } from "./TypeDialog.vue?vue&type=template&id=4aed2dfb&scoped=true"
import script from "./TypeDialog.vue?vue&type=script&lang=ts"
export * from "./TypeDialog.vue?vue&type=script&lang=ts"
import style0 from "./TypeDialog.vue?vue&type=style&index=0&id=4aed2dfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed2dfb",
  null
  
)

export default component.exports